<ul class="l-main-content main-content">
    <li class="l-section section  section--is-active">
        <div class="intro">
            <app-home></app-home>
        </div>
    </li>
    <li class="l-section section why-us">
        <div class="inner-why">
            <app-why-us></app-why-us>
        </div>
    </li>
    <li class="l-section section service">
        <div class="inner-services">
            <app-services></app-services>
        </div>
    </li>
    <li class="l-section section service">
        <div class="inner-clients">
            <app-clients></app-clients>
        </div>
    </li>
    <li class="l-section section service">
        <div class="inner-brain">
            <app-brain></app-brain>
        </div>
    </li>
    <li class="l-section section service">
        <div class="bounce_img">
            <img src="assets/Group 34.png" alt="">
        </div>
        <div class="inner-contact">
            <app-contact></app-contact>
        </div>
    </li>
</ul>
<!-- <app-why-us></app-why-us>
<app-services></app-services>
<app-clients></app-clients> -->
